<template>
  <div class="rating-con-add">
    <h4 class="rating-title-add">
      {{
        field.is_mandatory && !field.is_optional
          ? ratingScale.name
          : ratingScale.name + ` ${$t("common.optionalWithBrackets")}`
      }}
    </h4>

    <div
      class="d-flex align-items-center"
      :class="{'labels-container': showAs === 'labels'}"
      style="flex-wrap: wrap; row-gap: 16px"
    >
      <!-- start::Labels -->
      <template v-if="showAs === 'labels'">
        <span
          v-for="scaleIndex in scaleCount"
          @click="selectRating(scaleIndex)"
          :key="scaleIndex"
          class="vp-mr-8 numbers rating-label"
          :class="{ 'bg-blue': ratingScale.value == scaleIndex }"
          >{{ scaleIndex }}</span
        >
      </template>
      <!-- end::Labels -->

      <!-- start::Stars -->
      <template v-else-if="showAs === 'stars'">
        <span
          class="vp-mr-8 rating-label"
          :class="{ 'star-container': starIndex <= ratingScale.value }"
          v-for="starIndex in scaleCount"
          :key="starIndex"
          @click="selectRating(starIndex)"
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            :fill="starIndex <= ratingScale.value ? '#103F5E' : 'none'"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.3617 24.7895C15.1365 24.6655 14.8635 24.6655 14.6383 24.7895L6.63244 29.1971C6.63237 29.1971 6.6323 29.1971 6.63223 29.1972C6.48701 29.2767 6.34018 29.2582 6.21688 29.1648C6.09075 29.0692 6.00489 28.9022 6.03931 28.6907C6.03931 28.6907 6.03932 28.6907 6.03932 28.6906L7.57059 19.3534C7.60924 19.1178 7.53338 18.8779 7.36632 18.7073L0.890697 12.0949L0.889112 12.0933C0.756863 11.9591 0.718807 11.7708 0.774427 11.5911C0.829692 11.4125 0.95551 11.3044 1.10996 11.2812L1.11156 11.281L10.0624 9.91808C10.3093 9.88048 10.5213 9.72243 10.6279 9.49651L14.6345 0.999694L14.6352 0.998264C14.7883 0.671773 15.2101 0.661801 15.3724 1.00103C15.3726 1.00139 15.3727 1.00174 15.3729 1.00209L19.372 9.4961C19.4784 9.72223 19.6905 9.88046 19.9376 9.91808L28.8884 11.281L28.89 11.2812C29.0445 11.3044 29.1703 11.4125 29.2256 11.5911C29.2812 11.7708 29.2431 11.9591 29.1109 12.0933L29.1093 12.0949L22.6337 18.7073C22.4666 18.8779 22.3908 19.1178 22.4294 19.3534L23.9607 28.6906C23.9953 28.9027 23.9088 29.0717 23.7822 29.1679C23.6594 29.2613 23.5151 29.279 23.3714 29.1992L23.3687 29.1977L15.3617 24.7895Z"
              stroke="#787878"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </template>
      <!-- end::Stars -->

      <!-- start::Smileys -->
      <template v-else-if="showAs === 'smileys'">
        <div
          v-for="(smiley, smileyIndex) in getVisibleSmileys(scaleCount)"
          @click="selectRating(smileyIndex + 1)"
          :key="smileyIndex"
          class="vp-mr-8 rating-label"
          :class="{
            'selected-smiley-container': ratingScale.value == smileyIndex + 1,
          }"
          :style="{
            opacity:
              !ratingScale.value || ratingScale.value == smileyIndex + 1
                ? 1
                : '55%',
          }"
        >
          <div
            class="d-flex align-items-center justify-content-center"
            style="
              position: relative;
              flex-direction: column;
              height: 100%;
              width: 100%;
            "
          >
            <span
              v-html="getSmileySvg(smiley + 'Colored')"
              :class="{ 'smiley-span': ratingScale.value == smileyIndex + 1 }"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                width: 100%;
              "
            ></span>
            <p
              v-if="ratingScale.value == smileyIndex + 1"
              class="smiley-text"
              :style="{
                color: smileysColors[smileyIndex],
                bottom:
                  isAddVisit || preReg
                    ? '-34px'
                    : isSignInMassAction || signin || isEdit
                    ? '-18px'
                    : '-15px',
              }"
              style="position: absolute"
            >
              {{ smileysText[smileyIndex] }}
            </p>
          </div>
        </div>
      </template>
      <!-- end::Smileys -->
    </div>
  </div>
</template>

<script>
import smileysJson from "@/router/views/customFields/smileys.json";

import { cloneDeep } from "lodash";
export default {
  props: [
    "field",
    "isAddVisit",
    "preReg",
    "isEdit",
    "signin",
    "isSignInMassAction",
  ],
  data() {
    return {
      ratingScale: null,
      showAs: null,
      scaleCount: null,
      smileysColors: null,
      smileysText: null,
    };
  },
  methods: {
    getVisibleSmileys(scaleCount) {
      const smileysToShow = [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
        ],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ];

      return smileysToShow[scaleCount - 2];
    },
    setSmileysColor(scaleCount) {
      let smileyColors = [];
      switch (scaleCount) {
        case 2:
          smileyColors = ["rgb(230, 10, 62)", "rgb(25, 179, 148)"];
          break;
        case 3:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(255, 152, 20)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 4:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(246, 104, 34)",
            "rgb(178, 161, 62)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 5:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(242, 81, 41)",
            "rgb(255, 152, 20)",
            "rgb(140, 165, 84)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 6:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(240, 66, 45)",
            "rgb(250, 123, 28)",
            "rgb(209, 157, 45)",
            "rgb(117, 168, 96)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 7:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(238, 57, 48)",
            "rgb(246, 104, 34)",
            "rgb(255, 152, 20)",
            "rgb(178, 161, 62)",
            "rgb(101, 170, 105)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 8:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(237, 50, 50)",
            "rgb(244, 91, 38)",
            "rgb(251, 131, 26)",
            "rgb(222, 155, 38)",
            "rgb(156, 163, 74)",
            "rgb(90, 171, 111)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 9:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(236, 45, 51)",
            "rgb(242, 81, 41)",
            "rgb(248, 116, 30)",
            "rgb(255, 152, 20)",
            "rgb(197, 158, 52)",
            "rgb(140, 165, 84)",
            "rgb(82, 172, 116)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 10:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(235, 41, 52)",
            "rgb(241, 73, 43)",
            "rgb(246, 104, 34)",
            "rgb(252, 136, 24)",
            "rgb(229, 155, 34)",
            "rgb(178, 161, 62)",
            "rgb(127, 167, 91)",
            "rgb(76, 173, 119)",
            "rgb(25, 179, 148)",
          ];
          break;
      }

      return smileyColors;
    },
    setSmileysText(scaleCount) {
      let smileyText = [];
      switch (scaleCount) {
        case 3:
          smileyText = [this.$t('customFields.smileys.poor'),this.$t('customFields.smileys.ok'), this.$t('customFields.smileys.good')];
          break;
        case 5:
          smileyText = [this.$t('customFields.smileys.bad'), this.$t('customFields.smileys.poor'), this.$t('customFields.smileys.ok'), this.$t('customFields.smileys.good'), this.$t('customFields.smileys.great')];
          break;
      }
      return smileyText;
    },
    getSmileySvg(smiley) {
      return smileysJson[smiley];
    },
    selectRating(val) {
      if (val == this.ratingScale.value) this.ratingScale.value = null;
      else this.ratingScale.value = val;
      this.$emit("updateRating", this.ratingScale);
    },
  },
  beforeMount() {
    this.ratingScale = cloneDeep(this.field);
    this.ratingScale.metadata = this.field.metadata;
    this.showAs = this.ratingScale.metadata[0].show_as;
    this.scaleCount = this.ratingScale.metadata[0].scale_count;
    if (this.showAs == "smileys")
      this.smileysColors = this.setSmileysColor(this.scaleCount);
    this.smileysText = this.setSmileysText(this.scaleCount);
  },
};
</script>

<style lang="scss">
.smiley-span svg {
  width: 38px;
  height: 38px;
}
.smiley-text {
  font-style: normal;
  font-weight: 900;
  font-size: 9px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
}
.rating-modal {
  margin: auto;
  h4.rating-title-add {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 32px;
    line-height: 19.2px;
    color: #4A4A4A;
  }

  span.vp-mr-8.numbers {
    border: solid 1.5px #787878;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #787878 !important;
    font-weight: 600;
    font-size: 16px;
    line-height: 17px;
  }
  .rating-label {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rating-label:hover {
    cursor: pointer;
  }
  span.vp-mr-8.numbers.bg-blue {
    background-color: #103f5e !important;
    color: #ffffff !important;
    border: none !important;
  }
}

.selected-smiley-container {
  width: 38px !important;
  height: 38px !important;
}
.star-container {
  svg path {
    stroke: #103f5e !important;
  }
}
.labels-container{
  direction:ltr;
  width: fit-content;
}
</style>
